import { gql, NetworkStatus, useQuery } from '@apollo/client'

import {
  ConsoleItemInformationQuery,
  ConsoleItemInformationQueryVariables,
  ConsoleSerialItemOwnersFragmentDoc,
  ItemDescriptionFragmentDoc,
  UserInfoFragmentDoc,
} from '@/clients/utoniq-core/schema'
import { useCurrentUser, useRouter } from '@/core'
import { makeViewModel } from '@/core/architecture'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { router } = useRouter<{ itemId: string; userId?: string }>()
  const { user } = useCurrentUser()
  const { itemId } = router.query

  const { data, fetchMore, networkStatus } = useQuery<
    ConsoleItemInformationQuery,
    ConsoleItemInformationQueryVariables
  >(QUERY, { variables: { id: itemId, userId: user?.uid } })

  return {
    state: {
      loading: networkStatus === NetworkStatus.loading,
      fetching: networkStatus === NetworkStatus.fetchMore,
      itemId: router.query.itemId,
      userId: user?.uid,
      artistId: user?.uid ?? '',
      user: data?.user ?? null,
      hasNextPage: !!data?.item?.serials?.pageInfo?.hasNextPage,
      item: data?.item ?? null,
    },
    actions: {
      async onFetchMore() {
        await fetchMore({
          variables: {
            id: itemId,
            userId: user?.uid,
            pageInput: {
              cursor: data?.item?.serials?.pageInfo.endCursor,
            },
          },
        })
      },
    },
  }
})

const QUERY = gql`
  query ConsoleItemInformation(
    $id: ID!
    $userId: ID
    $pageInput: PageInput
    $skuId: String
  ) {
    item(id: $id) {
      ...ItemDescription
      serials(pageInput: $pageInput) {
        ...ConsoleSerialItemOwners
      }
      itemObtainedCount
    }
    user(id: $userId) {
      ...UserInfo
    }
  }
  ${ItemDescriptionFragmentDoc}
  ${ConsoleSerialItemOwnersFragmentDoc}
  ${UserInfoFragmentDoc}
`
